import * as React from 'react';
import { memo } from 'react';
const SvgThicknessFine = (props) => (
  <svg width={168} height={128} viewBox="0 0 168 128" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M-50.3984 91.6647L96.2285 -52.9004L-48.3366 93.7265L-50.3984 91.6647ZM111.291 -37.7126L-35.3356 106.848L-33.2738 108.909L111.291 -37.7126ZM-20.1515 121.912L126.475 -22.6535L-18.0897 123.973L-20.1515 121.912ZM-5.02934 137.035L141.598 -7.53006L-2.96266 139.097L-5.02934 137.035ZM171.849 22.7205L25.2225 167.281L27.2843 169.347L171.849 22.7205ZM10.1003 152.157L156.727 7.5971L12.1621 154.224L10.1003 152.157ZM202.096 52.9674L55.4694 197.533L57.5312 199.594L202.096 52.9674ZM40.3472 182.404L186.974 37.844L42.409 184.471L40.3472 182.404Z"
      fill="#51574E"
    />
  </svg>
);
const Memo = memo(SvgThicknessFine);
export default Memo;
